// component
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import DescriptionIcon from '@mui/icons-material/Description';
import SettingsIcon from '@mui/icons-material/Settings';
import HandshakeIcon from '@mui/icons-material/Handshake';
import BoltIcon from '@mui/icons-material/Bolt';
import HelpIcon from '@mui/icons-material/Help';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ApprovalIcon from '@mui/icons-material/Approval';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SvgColor from '../../../components/svg-color';
import { SUPPORT_WHATSAPP_URL } from '../../../utils/constants';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
    roles: null
  },
  {
    title: 'Cadastros',
    icon: <PersonAddIcon />,
    roles: null,
    children: [
  {
    title: 'Assinantes',
    path: '/dashboard/signers',
    icon: <PersonIcon />,
    roles: null
  },
  {
    title: 'Grupos',
    path: '/dashboard/groups',
    icon: <GroupIcon />,
    roles: null
  },
    ]
  },
  {
    title: 'Documentos',
    icon: <FolderIcon />,
    roles: null,
    children: [
      {
        title: 'Envelopes',
        path: '/dashboard/envelopes',
        icon: <EmailIcon />,
        roles: null
  },
  {
    title: 'Templates',
    path: '/dashboard/templates',
    icon: <DescriptionIcon />,
    roles: null
  },
  {
    title: 'Assinaturas Rapidas',
    path: '/dashboard/xpress/signature',
    icon: <BoltIcon />,
    roles: null
  },
  {
    title: 'Endossos',
    path: '/dashboard/endorsements',
    icon: <HandshakeIcon />,
        roles: null
      },
    ]
  },
  {
    title: 'Assinaturas',
    icon: <BorderColorIcon />,
    roles: null,
    children: [
      {
        title: 'Minhas Assinaturas',
        path: '/dashboard/my-signatures',
        icon: <AssignmentIcon />,
        roles: null
      },
      {
        title: 'Chancela Automática',
        path: '/dashboard/chancela-automatica',
        icon: <ApprovalIcon />,
        roles: null
      },
      {
        title: 'Assinaturas pendentes',
        path: '/dashboard/pendingSignatures',
        icon: <PendingActionsIcon />,
        roles: null
      },
    ]
  },
  {
    title: 'Configurações',
    icon: <SettingsIcon />,
    roles: null,
    children: [
  {
    title: 'Configuração',
    path: '/dashboard/configuration',
    icon: <SettingsIcon />,
    roles: null
  },
      {
        title: 'Usuarios',
        path: '/dashboard/user',
        icon: <ManageAccountsIcon />,
        roles: 'manager'
      },
  {
    title: 'Ajuda',
    path: SUPPORT_WHATSAPP_URL,
    icon: <HelpIcon />,
    roles: null
      },
    ]
  },
];

/** Menu quando a organização não tem plano ativo (apenas fluxos com JWT do usuário). */
export const navConfigNoActivePlan = [
  {
    title: 'Assinaturas',
    icon: <BorderColorIcon />,
    roles: null,
    children: [
      {
        title: 'Assinaturas pendentes',
        path: '/dashboard/pendingSignatures',
        icon: <PendingActionsIcon />,
        roles: null,
      },
      {
        title: 'Minhas Assinaturas',
        path: '/dashboard/my-signatures',
        icon: <AssignmentIcon />,
        roles: null,
      },
    ],
  },
];

export default navConfig;
